module.exports = __webpack_public_path__ + "static/img/5433_phase_function_Paper_PointsHejduk_Prediction.e6d5173.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5433_phase_function_Paper_PointsHejduk_Prediction.png
// module id = s9oB
// module chunks = 0